import { Loadable, LoadingPage } from 'components';
import { SystemDatetimeProvider } from 'contexts/system-datetime';
import ErrorBoundary from 'pages/500';
import { RouterProvider, createBrowserRouter } from 'react-router-dom';
import { routes } from 'routes';

function App() {
  const router = createBrowserRouter(routes);

  return (
    <ErrorBoundary>
      <LoadingPage>
        <Loadable>
          <SystemDatetimeProvider>
            <RouterProvider router={router} />
          </SystemDatetimeProvider>
        </Loadable>
      </LoadingPage>
    </ErrorBoundary>
  );
}

export default App;
